export { Site }

/**
 * Interface for site controllers used by the Router class
 * 
 * @author rhess <robin.hess@awi.de>
 * @memberof vef.utils
 */
class Site {

    /**
	 * initialize the page constructor.
	 * Gets called by Router.
	 * 
	 * @param params URL parameters
	 * @param config site specifig config
	 */
    constructor() { }

	/**
	 * Update page content when the Router navigates on the same site.
	 * Gets called by Router.
	 * 
	 * @param params URL parameters
	 */
    update(params) { }

	/**
	 * Clear unused instances to free up memory.
	 * Not necessary for most obects due to garbage collection.
	 * Required for ThreeJS WebGL Applications.
	 * 
	 * Gets called by Router.
	 */
	dispose() { }

}